import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight, CheckCircle2, Clock, AlertCircle, FileEdit, TrendingUp, Star, Zap, FileText, Plus, Users, BarChart3, ChevronRight } from 'lucide-react';
export function Dashboard() {
  return <div className="space-y-8 animate-in fade-in duration-500 pb-8" data-id="element-1089" data-mp="13qaj3l23zjah">
      {/* Header */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-end gap-4" data-id="element-1090" data-mp="yrg0aj455uqd">
        <div data-id="element-1091" data-mp="b1v9je1qxt6j">
          <h1 className="text-2xl font-semibold text-slate-900" data-id="element-1092" data-mp="60pdp7cshpss">Dashboard</h1>
          <p className="text-slate-500 mt-1" data-id="element-1093" data-mp="62sdgj3quxap">
            Here's an overview of your assessment activity.
          </p>
        </div>
        <Link to="/app/assessments/new" className="bg-slate-900 text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-slate-800 transition-colors flex items-center shrink-0" data-id="element-1094" data-mp="fz5395w64r06">
          <Plus className="h-4 w-4 mr-2" data-id="element-1095" data-mp="1retrs1p2ly33" />
          New Assessment
        </Link>
      </div>

      {/* 1-4: Top Metrics Row */}
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-1096" data-mp="21p55hx5xzoya">
        {/* Active Assessments */}
        <div className="bg-white p-5 rounded-xl border border-slate-200 shadow-sm flex flex-col justify-between" data-id="element-1097" data-mp="26ngiuhvg4hl9">
          <div className="flex justify-between items-start mb-4" data-id="element-1098" data-mp="2bom7o4lzjkpi">
            <div className="text-sm font-medium text-slate-500" data-id="element-1099" data-mp="2foekitiewd0o">
              Active Assessments
            </div>
            <div className="p-2 bg-emerald-50 text-emerald-600 rounded-lg" data-id="element-1100" data-mp="1j0qfnd7d2gz2">
              <Zap className="h-4 w-4" data-id="element-1101" data-mp="1nxgrfoc4uqeo" />
            </div>
          </div>
          <div data-id="element-1102" data-mp="1s03rudmvdjnh">
            <div className="text-3xl font-semibold text-slate-900" data-id="element-1103" data-mp="1rzllupaenr2d">3</div>
            <div className="mt-2 text-xs text-emerald-600 flex items-center font-medium" data-id="element-1104" data-mp="1wqk59xqox59u">
              <ArrowUpRight className="h-3 w-3 mr-1" data-id="element-1105" data-mp="1wsetbkx9ddi5" />
              <span data-id="element-1106" data-mp="107w997nszx6g">1 ending this week</span>
            </div>
          </div>
        </div>

        {/* Draft Assessments */}
        <div className="bg-white p-5 rounded-xl border border-slate-200 shadow-sm flex flex-col justify-between" data-id="element-1107" data-mp="148g424kwmopf">
          <div className="flex justify-between items-start mb-4" data-id="element-1108" data-mp="27iu230c0iqdh">
            <div className="text-sm font-medium text-slate-500" data-id="element-1109" data-mp="22lke7p49umrr">Drafts</div>
            <div className="p-2 bg-slate-100 text-slate-600 rounded-lg" data-id="element-1110" data-mp="2h9yepte7tz55">
              <FileEdit className="h-4 w-4" data-id="element-1111" data-mp="2cc5b984arj8k" />
            </div>
          </div>
          <div data-id="element-1112" data-mp="2ce9d7kimy867">
            <div className="text-3xl font-semibold text-slate-900" data-id="element-1113" data-mp="1om2jyu87ihb0">2</div>
            <div className="mt-2 text-xs text-slate-500 flex items-center" data-id="element-1114" data-mp="1oof1x7dysro2">
              <Clock className="h-3 w-3 mr-1" data-id="element-1115" data-mp="1josooxy4zbf9" />
              <span data-id="element-1116" data-mp="1xmr13xswcxs4">Last edited 2h ago</span>
            </div>
          </div>
        </div>

        {/* Completed Assessments */}
        <div className="bg-white p-5 rounded-xl border border-slate-200 shadow-sm flex flex-col justify-between" data-id="element-1117" data-mp="1tkcf54txlhwm">
          <div className="flex justify-between items-start mb-4" data-id="element-1118" data-mp="390l0f33hvql5">
            <div className="text-sm font-medium text-slate-500" data-id="element-1119" data-mp="3513wwf7mp3im">Completed</div>
            <div className="p-2 bg-blue-50 text-blue-600 rounded-lg" data-id="element-1120" data-mp="3ck3f4hjcsp0e">
              <CheckCircle2 className="h-4 w-4" data-id="element-1121" data-mp="3cm6c5lixbiem" />
            </div>
          </div>
          <div data-id="element-1122" data-mp="3hkrdxpdtqa56">
            <div className="text-3xl font-semibold text-slate-900" data-id="element-1123" data-mp="3hh3i2jkwpbna">15</div>
            <div className="mt-2 text-xs text-slate-500 flex items-center" data-id="element-1124" data-mp="32n7aimwksn14">
              <span className="text-slate-400" data-id="element-1125" data-mp="37k796cr3ini7">This quarter</span>
            </div>
          </div>
        </div>

        {/* Awaiting Responses */}
        <div className="bg-white p-5 rounded-xl border border-slate-200 shadow-sm flex flex-col justify-between" data-id="element-1126" data-mp="3vco1rh8glxvr">
          <div className="flex justify-between items-start mb-4" data-id="element-1127" data-mp="464l3lfxzdpj">
            <div className="text-sm font-medium text-slate-500" data-id="element-1128" data-mp="3lk8i8fhil18r">
              Awaiting Responses
            </div>
            <div className="p-2 bg-amber-50 text-amber-600 rounded-lg" data-id="element-1129" data-mp="3qhrvpd6e19zn">
              <Clock className="h-4 w-4" data-id="element-1130" data-mp="i39mv98mhqez" />
            </div>
          </div>
          <div data-id="element-1131" data-mp="mv1b3d4b3k1y">
            <div className="text-3xl font-semibold text-slate-900" data-id="element-1132" data-mp="mvjin5wf5kp6">12</div>
            <div className="mt-2 text-xs text-amber-600 flex items-center font-medium" data-id="element-1133" data-mp="2vcdl3jji3hcr">
              <AlertCircle className="h-3 w-3 mr-1" data-id="element-1134" data-mp="2qd0zf24d8gbr" />
              <span data-id="element-1135" data-mp="2qbg06z73w97k">4 overdue</span>
            </div>
          </div>
        </div>
      </div>

      {/* Middle Row: Score & Quick Actions */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-1136" data-mp="2getiukdzo0aa">
        {/* 5: Overall Leadership Score */}
        <div className="bg-slate-900 rounded-xl border border-slate-800 shadow-sm p-6 text-white relative overflow-hidden" data-id="element-1137" data-mp="3e2v8d8lkdkqq">
          <div className="absolute top-0 right-0 p-6 opacity-10 pointer-events-none" data-id="element-1138" data-mp="394aa3epvhb4x">
            <Star className="h-32 w-32" data-id="element-1139" data-mp="34bqt07rz7xvd" />
          </div>
          <h2 className="text-lg font-medium text-slate-200 mb-6" data-id="element-1140" data-mp="34a60enp82p05">
            Overall Leadership Score
          </h2>
          <div className="flex items-end gap-4 mb-6" data-id="element-1141" data-mp="n5o8vmg6jun">
            <div className="text-6xl font-bold tracking-tight" data-id="element-1142" data-mp="oqhmhx0zwqx">4.2</div>
            <div className="text-slate-400 mb-2 font-medium" data-id="element-1143" data-mp="3s11wvy4mi8dq">/ 5.0 Avg</div>
          </div>

          <div className="space-y-3" data-id="element-1144" data-mp="464t7gmt806y">
            <div className="flex justify-between text-sm" data-id="element-1145" data-mp="4761xegcsali">
              <span className="text-slate-300" data-id="element-1146" data-mp="866liz6nnh9k">Organization Benchmark</span>
              <span className="font-medium text-emerald-400 flex items-center" data-id="element-1147" data-mp="d6aywgc9nvvk">
                <TrendingUp className="h-4 w-4 mr-1" data-id="element-1148" data-mp="d8dztveyj9f2" />
                Top 15%
              </span>
            </div>
            <div className="w-full bg-slate-800 rounded-full h-2" data-id="element-1149" data-mp="n4h00vq90xzd">
              <div className="bg-emerald-400 h-2 rounded-full" style={{
              width: '84%'
            }} data-id="element-1150" data-mp="n24niy39fftp"></div>
            </div>
          </div>
        </div>

        {/* 7: Quick Actions */}
        <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-6" data-id="element-1151" data-mp="10vvohi2xdrdt">
          <h2 className="text-lg font-medium text-slate-900 mb-4" data-id="element-1152" data-mp="15v8hyloaxwpd">
            Quick Actions
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-id="element-1153" data-mp="1at0bfk4lhqvo">
            <Link to="/app/assessments" className="flex items-center p-4 border border-slate-200 rounded-lg hover:border-slate-300 hover:bg-slate-50 transition-all group" data-id="element-1154" data-mp="l5ntawziznnd">
              <div className="bg-indigo-50 p-2 rounded-md text-indigo-600 mr-3 group-hover:bg-indigo-100 transition-colors" data-id="element-1155" data-mp="uv7ewaemhvlx">
                <Zap className="h-5 w-5" data-id="element-1156" data-mp="q3plq8iuczbi" />
              </div>
              <div className="text-sm font-medium text-slate-900" data-id="element-1157" data-mp="13w5hco9exv2e">
                Launch Cycle
              </div>
            </Link>

            <Link to="/app/reports" className="flex items-center p-4 border border-slate-200 rounded-lg hover:border-slate-300 hover:bg-slate-50 transition-all group" data-id="element-1158" data-mp="yw118zcf32cp">
              <div className="bg-blue-50 p-2 rounded-md text-blue-600 mr-3 group-hover:bg-blue-100 transition-colors" data-id="element-1159" data-mp="18wjqyaqnxd2j">
                <BarChart3 className="h-5 w-5" data-id="element-1160" data-mp="3flyczf6hxa7f" />
              </div>
              <div className="text-sm font-medium text-slate-900" data-id="element-1161" data-mp="3ann2r3cagxoo">
                View Insights
              </div>
            </Link>

            <Link to="/app/team" className="flex items-center p-4 border border-slate-200 rounded-lg hover:border-slate-300 hover:bg-slate-50 transition-all group" data-id="element-1162" data-mp="1q6npph7porh9">
              <div className="bg-emerald-50 p-2 rounded-md text-emerald-600 mr-3 group-hover:bg-emerald-100 transition-colors" data-id="element-1163" data-mp="1gcn9okaw61tr">
                <Users className="h-5 w-5" data-id="element-1164" data-mp="17ebfk8atglwk" />
              </div>
              <div className="text-sm font-medium text-slate-900" data-id="element-1165" data-mp="17g60vnq02g16">
                Manage Team
              </div>
            </Link>

            <Link to="/app/settings" className="flex items-center p-4 border border-slate-200 rounded-lg hover:border-slate-300 hover:bg-slate-50 transition-all group" data-id="element-1166" data-mp="xg5etu0qxlta">
              <div className="bg-slate-100 p-2 rounded-md text-slate-600 mr-3 group-hover:bg-slate-200 transition-colors" data-id="element-1167" data-mp="2rtn2ri52ckou">
                <FileText className="h-5 w-5" data-id="element-1168" data-mp="2wrons8m1uu2y" />
              </div>
              <div className="text-sm font-medium text-slate-900" data-id="element-1169" data-mp="1jmo9yd1zjbtv">
                Templates
              </div>
            </Link>
          </div>
        </div>
      </div>

      {/* Bottom Row: Action Items & Recent Reports */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-1170" data-mp="1asjpcbdg2wms">
        {/* Action Items (Contextual to user) */}
        <div className="space-y-4" data-id="element-1171" data-mp="15u8dxw7i4e2g">
          <h2 className="text-lg font-medium text-slate-900" data-id="element-1172" data-mp="10vngg4jmw8hp">
            Your Action Items
          </h2>
          <div className="bg-white border border-slate-200 rounded-xl overflow-hidden shadow-sm" data-id="element-1173" data-mp="vwu0m5gvk5ed">
            <div className="divide-y divide-slate-100" data-id="element-1174" data-mp="rup7r8y93css">
              <div className="p-4 flex items-start hover:bg-slate-50 transition-colors" data-id="element-1175" data-mp="rv8rmv7gob9g">
                <div className="mt-0.5 bg-amber-100 text-amber-600 p-1.5 rounded-md mr-4 shrink-0" data-id="element-1176" data-mp="mxgot65a34qh">
                  <Clock className="h-4 w-4" data-id="element-1177" data-mp="2m8hsxzpusqgm" />
                </div>
                <div className="flex-1 min-w-0 pr-4" data-id="element-1178" data-mp="2h9nbb13mh7y3">
                  <h4 className="text-sm font-medium text-slate-900 truncate" data-id="element-1179" data-mp="2h7u6lrckkxsq">
                    Complete Self-Assessment
                  </h4>
                  <p className="text-xs text-slate-500 mt-1 truncate" data-id="element-1180" data-mp="2trr1jqqjcl4m">
                    Q3 Leadership Review • Due Tomorrow
                  </p>
                </div>
                <button className="text-sm font-medium text-slate-900 border border-slate-200 px-3 py-1.5 rounded-md hover:bg-slate-100 shrink-0" data-id="element-1181" data-mp="33ic7jz8jgrxk">
                  Start
                </button>
              </div>

              <div className="p-4 flex items-start hover:bg-slate-50 transition-colors" data-id="element-1182" data-mp="2at520gao322t">
                <div className="mt-0.5 bg-blue-100 text-blue-600 p-1.5 rounded-md mr-4 shrink-0" data-id="element-1183" data-mp="2fszpe9v8h9j4">
                  <AlertCircle className="h-4 w-4" data-id="element-1184" data-mp="2ju38r6chpnp3" />
                </div>
                <div className="flex-1 min-w-0 pr-4" data-id="element-1185" data-mp="2js06nny2c440">
                  <h4 className="text-sm font-medium text-slate-900 truncate" data-id="element-1186" data-mp="3r6v8ftp9e2fm">
                    Review Nominations
                  </h4>
                  <p className="text-xs text-slate-500 mt-1 truncate" data-id="element-1187" data-mp="3vbkzn58z2su7">
                    Michael Scott • 5 pending approvals
                  </p>
                </div>
                <button className="text-sm font-medium text-slate-900 border border-slate-200 px-3 py-1.5 rounded-md hover:bg-slate-100 shrink-0" data-id="element-1188" data-mp="1q2l4h7jgtaxh">
                  Review
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* 6: Recent Reports */}
        <div className="space-y-4" data-id="element-1189" data-mp="1278o37jyws97">
          <div className="flex justify-between items-center" data-id="element-1190" data-mp="128bhpn8od8st">
            <h2 className="text-lg font-medium text-slate-900" data-id="element-1191" data-mp="175tigqcjghpq">
              Recent Reports
            </h2>
            <Link to="/app/reports" className="text-sm font-medium text-slate-600 hover:text-slate-900 flex items-center" data-id="element-1192" data-mp="1c2jxrbgir9a3">
              View all <ChevronRight className="h-4 w-4 ml-0.5" data-id="element-1193" data-mp="2ni8j5ye4k08s" />
            </Link>
          </div>
          <div className="bg-white border border-slate-200 rounded-xl overflow-hidden shadow-sm" data-id="element-1194" data-mp="2shlel7j2afmz">
            <div className="divide-y divide-slate-100" data-id="element-1195" data-mp="gvax8h6shi5x">
              {[{
              name: 'Sarah Connor',
              role: 'Director of Engineering',
              date: 'Today',
              score: '4.6'
            }, {
              name: 'Jim Halpert',
              role: 'Sales Lead',
              date: 'Yesterday',
              score: '4.2'
            }, {
              name: 'Pam Beesly',
              role: 'Office Administrator',
              date: 'Oct 12',
              score: '4.8'
            }].map((report, i) => <Link key={i} to="/app/reports" className="p-4 flex items-center justify-between hover:bg-slate-50 transition-colors group" data-id="element-1196" data-mp="3fcwz4jub0no5" data-mpi={i}>
                  <div className="flex items-center min-w-0" data-id="element-1197" data-mp="1dks6t78w7ocw">
                    <div className="w-10 h-10 rounded-full bg-slate-100 border border-slate-200 flex items-center justify-center text-sm font-medium text-slate-600 mr-3 shrink-0" data-id="element-1198" data-mp="1djh7bjmhd2rl">
                      {report.name.split(' ').map(n => n[0]).join('')}
                    </div>
                    <div className="min-w-0" data-id="element-1199" data-mp="333h14qrad4gu">
                      <div className="text-sm font-medium text-slate-900 truncate" data-id="element-1200" data-mp="3302xlf6vyp7t">
                        {report.name}
                      </div>
                      <div className="text-xs text-slate-500 truncate" data-id="element-1201" data-mp="3vq1tnujhzmlz">
                        {report.role} • {report.date}
                      </div>
                    </div>
                  </div>
                  <div className="flex items-center ml-4 shrink-0" data-id="element-1202" data-mp="3lrvon42ea0cw">
                    <div className="text-right mr-3" data-id="element-1203" data-mp="25ex9ipadabkk">
                      <div className="text-sm font-semibold text-slate-900" data-id="element-1204" data-mp="25dcd0u4hsik2">
                        {report.score}
                      </div>
                      <div className="text-[10px] text-slate-500 uppercase tracking-wider" data-id="element-1205" data-mp="sflwjd0qeucd">
                        Score
                      </div>
                    </div>
                    <div className="text-slate-400 group-hover:text-slate-900 transition-colors" data-id="element-1206" data-mp="njelx6xe4uo3">
                      <ChevronRight className="h-5 w-5" data-id="element-1207" data-mp="11eh1ymvyc0em" />
                    </div>
                  </div>
                </Link>)}
            </div>
          </div>
        </div>
      </div>
    </div>;
}